import { render, staticRenderFns } from "./AccountDeletedView.vue?vue&type=template&id=d4a0cf08&"
import script from "./AccountDeletedView.vue?vue&type=script&lang=js&"
export * from "./AccountDeletedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports